export default __webpack_public_path__ + "static/media/OmnicureNowAppStore.934f29e6.jpg";